import { FormattedMessage } from "react-intl";

export const checkEnvironment = process.env.REACT_APP_RUNNING_CONTEXT;
export const checkMockup = process.env.REACT_APP_IS_MOCKUP;

export const deviceCategoryOption = {
  switch: {
    label: <FormattedMessage id="Switch" />,
    value: "switch",
    tabName: {
      portManagement: 'switches'
    }
  },
  ap: {
    label: <FormattedMessage id="Access Point" />,
    value: "ap",
    tabName: {
      portManagement: 'accessPoints'
    }
  },
  unknown: {
    label: <FormattedMessage id="Unknown" defaultMessage="Unknown" />,
    value: "unknown",
    tabName: {
      portManagement: 'switches'
    }
  },
  convertToForm: () => {
    return [
      {
        label: deviceCategoryOption.switch.label,
        value: deviceCategoryOption.switch.value,
      },
      {
        label: deviceCategoryOption.ap.label,
        value: deviceCategoryOption.ap.value,
      },
    ];
  },
};

export const portTypeOption = {
  access: {
    label: <FormattedMessage id="Access" />,
    value: "access",
  },
  trunk: {
    label: <FormattedMessage id="Trunk" />,
    value: "trunk",
  },
  convertToForm: () => {
    return [
      {
        label: portTypeOption.access.label,
        value: portTypeOption.access.value,
      },
      {
        label: portTypeOption.trunk.label,
        value: portTypeOption.trunk.value,
      },
    ];
  }
};

export const linkSpeedOption = {
  auto: {
    label: <FormattedMessage id="Auto (Default)" />,
    value: "auto",
  },
  "40g_full": {
    label: <FormattedMessage id="40G Gbps Full Duplex" />,
    value: "40G_full",
  },
  "25g_full": {
    label: <FormattedMessage id="25G Gbps Full Duplex" />,
    value: "25G_full",
  },
  "10g_full": {
    label: <FormattedMessage id="10G Gbps Full Duplex" />,
    value: "10G_full",
  },
  "5g_full": {
    label: <FormattedMessage id="5G Gbps Full Duplex" />,
    value: "5G_full",
  },
  "2.5g_full": {
    label: <FormattedMessage id="2.5 Gbps Full Duplex" />,
    value: "2.5G_full",
  },
  "1g_full": {
    label: <FormattedMessage id="1G Gbps Full Duplex" />,
    value: "1G_full",
  },
  "100m_full": {
    label: <FormattedMessage id="100 Mbps Full Duplex" />,
    value: "100M_full",
  },
  "100m_half": {
    label: <FormattedMessage id="100 Mbps Half Duplex" />,
    value: "100M_half",
  },
  convertToForm: () => {
    return [
      {
        label: linkSpeedOption.auto.label,
        value: linkSpeedOption.auto.value,
      },
      {
        label: linkSpeedOption["40g_full"].label,
        value: linkSpeedOption["40g_full"].value,
      },
      {
        label: linkSpeedOption["25g_full"].label,
        value: linkSpeedOption["25g_full"].value,
      },
      {
        label: linkSpeedOption["10g_full"].label,
        value: linkSpeedOption["10g_full"].value,
      },
      {
        label: linkSpeedOption["5g_full"].label,
        value: linkSpeedOption["5g_full"].value,
      },
      {
        label: linkSpeedOption["2.5g_full"].label,
        value: linkSpeedOption["2.5g_full"].value,
      },
      {
        label: linkSpeedOption["1g_full"].label,
        value: linkSpeedOption["1g_full"].value,
      },
      {
        label: linkSpeedOption["100m_full"].label,
        value: linkSpeedOption["100m_full"].value,
      },
      {
        label: linkSpeedOption["100m_half"].label,
        value: linkSpeedOption["100m_half"].value,
      },
    ];
  }
};

export const apiMappingKey = {
  id: "id",
  deviceCategory: "deviceCategory",
  profileName: "name",
  portTags: "portTags",
  portState: "portState",
  portType: "portType",
  pvid: "PVID",
  linkSpeed: "speed",
  fiberLinkSpeed: "sfpSpeed",
  poeState: "poeState",
  allowVlan: "allowVlan",
  ddpState: "ddpState",
  lbdState: "lbdState",
  assignedPort: "assignedPort",
};

export const defaultValue = {
  deviceCategory: deviceCategoryOption.switch.value,
  profileName: "", // String
  portTags: [], // Array of String
  portState: true,
  portType: portTypeOption.access.value,
  pvid: null, // Number
  linkSpeed: linkSpeedOption.auto.value,
  fiberLinkSpeed: linkSpeedOption.auto.value,
  poeState: true,
  allowVlan: null, // String
  ddpState: true,
  lbdState: true,
  assignedPort: [],
  makePayload: (values) => {
    const extraHandleKey = {
      pvid: "pvid",
      allowVlan: "allowVlan",
    }
    const editMode = values.id !== undefined && values.id !== null;
    const payload = {};

    for (const key in apiMappingKey) {
      if (key === "id" || key === "assignedPort") {
        continue;
      }

      if (key === extraHandleKey.pvid) {
        payload[apiMappingKey[key]] = Number(values[key]);
        continue;
      }

      payload[apiMappingKey[key]] = values[key];
    }

    if (!payload[extraHandleKey.allowVlan]) {
      payload[extraHandleKey.allowVlan] = "";
    }

    if (!editMode) {
      delete payload.id;
    }

    return payload;
  }
};
